import React from 'react';

import { useIntl } from 'react-intl';

import RadioButton from 'components/radio-button';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { StyledModalContent } from '../styled';

import { AddressContainer, AddressDetails, AddressDetailsHeader } from './styled';
import { IDeliveryAddressItemProps } from './types';

const DeliveryAddressItem: React.FC<IDeliveryAddressItemProps> = ({
  address,
  selected,
  onSelect,
}) => {
  const { formatMessage } = useIntl();

  const enableSimplifiedDelivery = useFlag(LaunchDarklyFlag.ENABLE_SIMPLE_DELIVERY_FORM);
  const FlaggedContainer = enableSimplifiedDelivery ? React.Fragment : StyledModalContent;

  return (
    <FlaggedContainer>
      <AddressContainer
        data-testid="delivery-address-item"
        enableSimplifiedDelivery={enableSimplifiedDelivery}
      >
        <RadioButton option={{}} size={1.5} checked={selected} onChange={onSelect} />
        <AddressDetails enableSimplifiedDelivery={enableSimplifiedDelivery}>
          <AddressDetailsHeader>
            {address.addressLine1}
            <div>
              {address.addressLine2 &&
                formatMessage({ id: 'unitNumber' }, { unitNumber: address.addressLine2 })}
            </div>
          </AddressDetailsHeader>
          <div>
            {address.city}, {address.state} {address.zip}
          </div>
          <div>{address.phoneNumber}</div>
        </AddressDetails>
      </AddressContainer>
    </FlaggedContainer>
  );
};

export default DeliveryAddressItem;
